<template>
    <app-layout>
      <Head title="Forms"/>
        <template #header>
            <div class="flex items-center">
                <Link
                    :href="route('web-forms.index')"
                    class="p-1 text-gray-500 hover:text-gray-900"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M11 17l-5-5m0 0l5-5m-5 5h12"
                        />
                    </svg>
                </Link>
                <h2
                    class="font-semibold text-xl text-gray-800 leading-tight ml-1"
                >
                    Edit Form
                </h2>
            </div>
        </template>
        <div class="max-w-7xl mx-auto flex pb-12 mb-12">
            <div class="w-full p-2 sm:px-6 lg:px-8">
                <div class="bg-white shadow-xl sm:rounded-lg p-4 sm:p-6 lg:p-8">
                    <h2
                        class="font-semibold text-xl text-gray-800 leading-tight mb-2"
                    >
                        Details
                    </h2>
                    <form @submit.prevent="update">
                        <div class="mt-6 grid grid-cols-6 gap-6">
                            <div class="col-span-12 lg:col-span-3">
                                <label
                                    for="form-name"
                                    class="block text-sm font-semibold text-gray-700"
                                    >Form name
                                    <span class="text-red-500">*</span></label
                                >
                                <input
                                    type="text"
                                    name="form-name"
                                    id="form-name"
                                    autocomplete="off"
                                    v-model="form.name"
                                    required
                                    class="mt-1 px-3 py-2 focus:border-gray-400 focus:outline-none block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md"
                                />
                                <p
                                    v-if="form.errors.name"
                                    class="text-red-500 text-sm mt-1"
                                >
                                    {{ form.errors.name }}
                                </p>
                            </div>
                            <div
                                class="col-start-1 col-span-12 lg:col-start-1 lg:col-span-3"
                            >
                                <h2 class="font-semibold mb-2">List</h2>
                                <label
                                    for="group"
                                    class="block text-sm font-semibold text-gray-700"
                                >
                                    All contacts that submit the form will be added to your selected TextSpot list.
                                </label>
                                <div class="mt-1">
                                    <select
                                        id="group"
                                        name="group"
                                        autocomplete="off"
                                        v-model="form.group"
                                        required
                                        @change="selectGroup"
                                        class="shadow-sm px-3 py-2 focus:border-gray-400 focus:outline-none block w-full sm:text-sm border border-gray-300 rounded-md"
                                    >
                                        <option value="" disabled selected
                                            >Please choose...</option
                                        >
                                        <option
                                            v-for="group in groups"
                                            :key="group.id"
                                            :value="group.id"
                                            >{{ group.title }}</option
                                        >
                                    </select>
                                </div>
                                <p
                                    v-if="form.errors.group"
                                    class="text-red-500 text-sm mt-1"
                                >
                                    {{ form.errors.group }}
                                </p>
                            </div>
                            <div class="col-span-12 col-start-1 bg-gray-100">
                                <div
                                    class="grid grid-cols-6 gap-6 border-t border-b p-5"
                                >
                                    <div class="col-span-12">
                                        <h2 class="font-semibold mb-2">
                                            Preview
                                        </h2>
                                    </div>
                                    <div class="col-span-12">
                                        <div class="grid grid-cols-12 gap-6">
                                            <div
                                                class="col-start-1 col-span-12 lg:col-start-4 lg:col-span-6"
                                            >
                                                <div
                                                    class="bg-white overflow-hidden shadow rounded-lg"
                                                >
                                                    <div
                                                        class="px-4 py-5 sm:p-6"
                                                    >
                                                        <div
                                                            class="grid grid-cols-12 gap-6"
                                                        >
                                                            <div
                                                                class="col-span-12 lg:col-span-6"
                                                            >
                                                                <label
                                                                    for="first-name"
                                                                    class="block text-sm font-semibold text-gray-700"
                                                                    >First name
                                                                    <span
                                                                        class="text-red-500"
                                                                        >*</span
                                                                    ></label
                                                                >
                                                                <input
                                                                    type="text"
                                                                    autocomplete="off"
                                                                    disabled
                                                                    class="mt-1 px-3 py-2 focus:border-gray-400 focus:outline-none block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md"
                                                                    value="John"
                                                                />
                                                            </div>
                                                            <div
                                                                class="col-span-12 lg:col-span-6"
                                                            >
                                                                <label
                                                                    for="last-name"
                                                                    class="block text-sm font-semibold text-gray-700"
                                                                    >Last name
                                                                    <span
                                                                        class="text-red-500"
                                                                        >*</span
                                                                    ></label
                                                                >
                                                                <input
                                                                    type="text"
                                                                    autocomplete="off"
                                                                    disabled
                                                                    class="mt-1 px-3 py-2 focus:border-gray-400 focus:outline-none block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md"
                                                                    value="Smith"
                                                                />
                                                            </div>
                                                            <div
                                                                class="col-span-12"
                                                            >
                                                                <label
                                                                    for="form-name"
                                                                    class="block text-sm font-semibold text-gray-700"
                                                                    >Phone
                                                                    <span
                                                                        class="text-red-500"
                                                                        >*</span
                                                                    ></label
                                                                >
                                                                <input
                                                                    type="text"
                                                                    autocomplete="off"
                                                                    disabled
                                                                    class="mt-1 px-3 py-2 focus:border-gray-400 focus:outline-none block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md"
                                                                    value="(xxx) xxx-xxxx"
                                                                />
                                                            </div>
                                                            <div
                                                                class="col-span-12"
                                                            >
                                                                <h2
                                                                    class="font-medium"
                                                                >
                                                                    Subscribing
                                                                    to list:
                                                                    <span
                                                                        class="font-bold"
                                                                        v-text="
                                                                            groupSelected.title
                                                                        "
                                                                    ></span>
                                                                </h2>
                                                            </div>
                                                            <div
                                                                class="col-span-12"
                                                            >
                                                                <div
                                                                    class="relative flex items-start"
                                                                >
                                                                    <div
                                                                        class="flex items-center h-5"
                                                                    >
                                                                        <input
                                                                            aria-describedby="terms-description"
                                                                            disabled
                                                                            type="checkbox"
                                                                            class="h-4 w-4 border-gray-300 rounded"
                                                                        />
                                                                    </div>
                                                                    <div
                                                                        class="ml-3 text-sm"
                                                                    >
                                                                        <label
                                                                            for="terms"
                                                                            class="font-medium text-gray-700"
                                                                            >Terms
                                                                            and
                                                                            conditions</label
                                                                        >
                                                                        <p
                                                                            id="terms-description"
                                                                            class="text-xs text-gray-500"
                                                                        >

                                                                        By providing a telephone number and submitting the form you are consenting to be contacted by SMS text message from {{ $page.props.auth.user.organization.title }}. Message frequency may vary. Message & data rates may apply. Reply STOP to opt out of further messaging. Reply HELP for more information. See our
                                                                            <span class="text-blue-500 underline cursor-pointer hover:text-blue-600">Privacy Policy</span>.
                                                                            See our
                                                                            <span class="text-blue-500 underline cursor-pointer hover:text-blue-600">Terms of Service</span>.
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="col-span-12"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    class="inline-flex items-center justify-center w-full font-semibold px-3 py-3 border border-transparent leading-4 font-medium rounded-md shadow-sm text-white bg-orange-400 hover:bg-orange-500 focus:outline-none"
                                                                >
                                                                    Subscribe
                                                                    now
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="mt-6">
                                                    <div
                                                        class="text-sm text-center text-gray-600"
                                                    >
                                                        SMS marketing powered by
                                                        <span
                                                            class="text-blue-500 underline hover:text-blue-600 cursor-pointer"
                                                            >TextSpot</span
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-span-12">
                                <h2 class="font-semibold mb-2">
                                    Form confirmation
                                </h2>
                                <p class="text-sm text-gray-500">
                                    This confirmation will be shown after your
                                    contact submits the form
                                </p>
                            </div>
                            <div class="col-span-12">
                                <label
                                    for="confirmation_text"
                                    class="block text-sm font-semibold text-gray-700"
                                    >Confirmation text
                                    <span class="text-red-500">*</span></label
                                >
                                <input
                                    type="text"
                                    name="confirmation_text"
                                    id="confirmation_text"
                                    autocomplete="off"
                                    v-model="form.confirmation_text"
                                    required
                                    class="mt-1 px-3 py-2 focus:border-gray-400 focus:outline-none block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md"
                                />
                                <p
                                    v-if="form.errors.confirmation_text"
                                    class="text-red-500 text-sm mt-1"
                                >
                                    {{ form.errors.confirmation_text }}
                                </p>
                            </div>
                            <div class="col-span-12">
                                <div class="flex justify-between items-start">
                                    <div>
                                        <button
                                            type="submit"
                                            :disabled="form.processing"
                                            class="inline-flex items-center px-4 py-2 mr-2 mb-2 bg-orange-400 border border-transparent rounded-md font-bold text-xs text-white uppercase tracking-widest hover:bg-orange-500 active:bg-orange-600 focus:outline-none focus:border-orange-600 focus:ring-orange transition ease-in-out duration-150"
                                        >
                                            Update form
                                        </button>
                                        <Link
                                            :href="route('web-forms.index')"
                                            class="inline-flex items-center px-4 py-2 bg-gray-400 border border-transparent rounded-md font-bold text-xs text-gray-700 uppercase tracking-widest hover:bg-gray-300 focus:outline-none transition ease-in-out duration-150"
                                        >
                                            Cancel
                                        </Link>
                                    </div>
                                    <button
                                        class="delete-webform-button inline-flex items-center px-4 py-2 bg-red-500 border border-transparent rounded-md font-bold text-xs text-white uppercase tracking-widest hover:bg-red-600 active:bg-red-600 focus:outline-none focus:border-red-600 focus:ring-red transition ease-in-out duration-150"
                                        tabindex="-1"
                                        type="button"
                                        @click="destroy"
                                    >
                                        Delete Form
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
export default {
    props: {
        webform: Object,
        groupsList: Array
    },
    data() {
        return {
            form: this.$inertia.form({
                name: this.webform.name,
                group: this.webform.group.id,
                confirmation_text: this.webform.confirmation_text
            }),
            groups: this.groupsList,
            groupSelected: this.webform.group
        };
    },
    methods: {
        update() {
            this.form.put(route("web-forms.update", this.webform.uuid), {
                onError: errors => {
                    console.log(errors);
                }
            });
        },
        destroy() {
            if (
                confirm(
                    "Are you sure you want to delete this form?"
                )
            ) {
                this.$inertia.delete(`/web-forms/${this.webform.uuid}`, {
                    onError: errors => {
                        console.log(errors);
                    }
                });
            }
        },
        selectGroup() {
            this.groupSelected = this.groups.find(
                ({ id }) => id === this.form.group
            );
        }
    }
};
</script>

<style>

.delete-webform-button {
    white-space: nowrap;
}

</style>
